import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Col, Container, Row } from 'reactstrap';
import axios from 'axios';

import ReactLoading from 'react-loading';
import EditLocation from './EditLocation';

class Locations extends Component {
  constructor(props) {
    super(props);
    document.title = 'InvaluableAuctions - Locations';
    this.state = {
      loading: true,
      selectedIndex: -1,
      showModal: false
    };
  }

  componentDidMount() {
    this.fetchLocations();
  }

  fetchLocations = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios('/app/house/address');
      const houseAddresses = get(response, 'data.data.houseAddresses', []);
      this.setState({ loading: false, locations: houseAddresses });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };

  handleLocationModal = (showModal, selectedIndex) => {
    this.setState({ showModal, selectedIndex });
  };

  deleteLocation = selectedIndex => {
    const { locations } = this.state;
    const selectedLocation = locations[selectedIndex];
    const { addressID } = selectedLocation;

    axios
      .get(`/app/house/address/address-delete/${addressID}`)
      .then(({ data: { data: { success } } }) => {
        if (success) {
          this.fetchLocations();
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    const { houseRef } = this.props;
    const { loading, locations, selectedIndex, showModal } = this.state;

    if (loading) {
      return (
        <ReactLoading className="loading-spinner" type="spin" color="black" />
      );
    }

    return (
      <Container className="py-4">
        <Row className="py-0 mb-0 mx-0">
          <Col xs={9} className="px-0">
            <h1>Locations</h1>
            {locations && locations.length >= 1 && (
              <p>
                To delete your current primary location, please designate a new
                primary location first.
              </p>
            )}
          </Col>

          <Col xs={3} className="align-right px-0">
            <Button
              color="primary"
              onClick={() => this.handleLocationModal(true, -1)}
            >
              <FontAwesomeIcon icon="plus" /> Add Location
            </Button>
          </Col>
        </Row>

        {!locations || (locations.length <= 0 && (
          <div>
            <p>You have not added any locations yet.</p>
          </div>
        ))}

        {locations && locations.map((location, index) => {
          const locationFacility = get(location, 'facilityName', '');
          const locationStreet = get(location, 'addressStreet1', '');
          const locationAddress = get(location, 'location', '');

          return (
            <div key={location.id}>
              <hr />
              <Row className="py-0 mx-0">
                <span>
                  <strong>
                    {locationFacility.length > 0 ? `${locationFacility}, ` : ''}
                  </strong>
                  {locationStreet.length > 0 ? `${locationStreet}, ` : ''}
                  {locationAddress}
                  {location.primary && (
                    <Badge className="ml-2 mt-2 pt-1 px-2" color="primary">
                      primary location
                    </Badge>
                  )}
                </span>{' '}
                <Col className="align-right px-0">
                  {!location.primary && (
                    <Button
                      className="px-3"
                      color="link"
                      onClick={() => this.deleteLocation(index)}
                      href="#nowhere"
                    >
                      <FontAwesomeIcon icon="trash-alt" /> Delete
                    </Button>
                  )}
                  <Button
                    className="px-3"
                    color="link"
                    onClick={() => this.handleLocationModal(true, index)}
                    href="#nowhere"
                  >
                    <FontAwesomeIcon icon="edit" /> Edit
                  </Button>
                </Col>
              </Row>
            </div>
          );
        })}

        <EditLocation
          fetchLocations={this.fetchLocations}
          handleLocationModal={this.handleLocationModal}
          houseRef={houseRef}
          index={selectedIndex}
          numLocations={locations.length || 0}
          showModal={showModal}
          values={locations[selectedIndex]}
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ house: { houseRef } }) => ({
  houseRef
});

export default connect(
  mapStateToProps,
  null
)(Locations);
